// @ts-nocheck
import { App } from "@adyen/adyen-web";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import constants from "@store/constants";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import {
    HeaderHeightParameter,
    HeaderIsFixedParameter,
    HeaderIsFullOpacityParameter,
} from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { Draft } from "immer";

type HeaderState = ApplicationState["bunzl"]["components"]["header"];

const initialState: HeaderState = {
    isFixed: false,
    isFullOpacity: false,
    headerHeight: {
        mainHeight: constants.defaultHeaderHeight.mainHeight,
        secondaryHeight: constants.defaultHeaderHeight.secondaryHeight,
        tabbedNavigationHeight: 0,
    },
};

const actions = {
    "Store/Components/Header/SetIsFixed": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderIsFixedParameter },
    ) => {
        draft.isFixed = action.parameter;
    },
    "Store/Components/Header/SetFullOpacity": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderIsFullOpacityParameter },
    ) => {
        draft.isFullOpacity = action.parameter.isFullOpacity;
    },
    "Store/Components/Header/SetHeaderHeight": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderHeightParameter },
    ) => {
        draft.headerHeight = action.parameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsHeaderActions = BunzlActionUnion<typeof actions>;
export default reducer;
